/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

export enum CAMPAIGN_ANALYSIS_DIMENSION {
  KEY_MESSAGE = 'key_message',
  PROOF_POINT = 'proof_point',
  HOOK = 'hook',
  OCCASION = 'occasion',
  POV = 'pov',
  STRUCTURE = 'structure',
  CONTENT_FORMAT = 'content_format',
  SHOT_TYPE = 'shot_type',
  PRODUCTION_VALUE = 'production_value',
  AUDIO = 'audio',
  TONE_AND_MOOD = 'tone_and_mood',
  CTA = 'cta',
}

export enum CAMPAIGN_ANALYSIS_FAILURE_REASON {
  SUBMIT_FAILED = 'submit_failed',
  OPTIMIZER_FAILED = 'optimizer_failed',
  TIMEOUT = 'timeout',
}

export enum CAMPAIGN_ANALYSIS_STATUS {
  REQUESTING = 'requesting',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export enum CAMPAIGN_ANALYSIS_TARGET_METRIC {
  VIEW_SCORE = 'view_score',
  ENGAGEMENT_SCORE = 'engagement_score',
}

export enum CAMPAIGN_LABEL {
  AFFILIATE = 'Affiliate',
  CASH_PAID = 'Cash-paid',
  GIFTING = 'Gifting',
}

export enum CAMPAIGN_ITEM_TYPE {
  HANDLE = 'handle',
  POST = 'post',
}

export enum CAMPAIGN_PLATFORM {
  TIKTOK = 'tiktok',
  INSTAGRAM = 'instagram',
}

export enum CAMPAIGN_STATUS {
  SCHEDULED = 'scheduled',
  ACTIVE = 'active',
  ENDED = 'ended',
}

export enum CAMPAIGN_POST_SOURCE {
  AUTO = 'auto',
  MANUAL = 'manual',
}

export enum CAMPAIGN_POST_SORT {
  POSTED_AT_DESC = 'posted_at_desc',
  VIEW_DESC = 'view_desc',
  LIKE_DESC = 'like_desc',
  SHARED_DESC = 'shared_desc',
  COMMENT_DESC = 'comment_desc',
  RATE_DESC = 'rate_desc',
}

export enum CAMPAIGN_SORT {
  START_DATE_DESC = 'start_date_desc',
  ENDING_DATE = 'ending_date',
}
